import { ReactNode } from 'react';

import { clsx } from 'clsx';

import { useTabs } from '../Tabs';
import cls from './TabPanel.module.scss';

type TabPanelProps = {
  className?: string;
  children: ReactNode;
  value: number | string;
};

export const TabPanel = ({ children, value, className }: TabPanelProps) => {
  const { activeTab } = useTabs();

  return <div className={clsx(cls.wrap, className, { [cls.visible]: activeTab === value.toString() })}>{children}</div>;
};
